import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { fade, Typography, useTheme } from '@material-ui/core';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Calendar from './index';
import Box from '@material-ui/core/Box';
import CmtGridView from '../../../@coremat/CmtGridView';
import axios from 'axios';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import GridContainer from '../../../@jumbo/components/GridContainer';
import Grid from '@material-ui/core/Grid';
import CmtCard from '../../../@coremat/CmtCard';
import CmtCardContent from '../../../@coremat/CmtCard/CmtCardContent';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { DatePicker } from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import Snackbar from '@material-ui/core/Snackbar';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import MuiAlert from '@material-ui/lab/Alert';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Switch from '@material-ui/core/Switch';
import Slider from '@material-ui/core/Slider';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function getMyDate(prop) {
  var md = new Date(prop);
  var dd = String(md.getDate()).padStart(2, '0');
  var mm = String(md.getMonth() + 1).padStart(2, '0');
  var yyyy = md.getFullYear();
  return yyyy + '-' + mm + '-' + dd;
}

const useStyles = theme => ({
  boxTop: {
    paddingTop: theme.spacing(5),
  },
  appBar: {
    position: 'relative',
  },
  root: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(5),
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  cardRoot: {
    '& .Cmt-header-root': {
      paddingTop: 10,
      paddingBottom: 0,
    },
  },
  tabsList: {
    position: 'relative',
    minHeight: 60,
    '& .MuiTabs-indicator': {
      backgroundColor: fade(theme.palette.primary.main, 0.8),
    },
  },
  formControl: {
    margin: theme.spacing(2),
    minWidth: 200,
  },
  tabItem: {
    maxWidth: 'none',
    minWidth: 10,
    minHeight: 60,
    padding: '5px 10px',
    textTransform: 'capitalize',
    color: theme.palette.text.primary,
    fontSize: 12,
    fontWeight: theme.typography.fontWeightRegular,
  },
  columnRoot: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.5px',
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function createData(name, dateOfBirth) {
  return { name, dateOfBirth };
}

class SettingsForm2 extends Component {
  //
  //const [open, setOpen] = React.useState(this.props.open);
  constructor(props) {
    super(props);
    this.props = props;

    var hotels = this.props.auth.authUser.hotels;
    var myroomTypes = this.props.auth.authUser.roomtypes;
    var today = new Date();
    //  today.setDate(today.getDate() + 3);
    var tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 30);

    this.checkDates = this.checkDates.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCustomChange = this.handleCustomChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
    var today = new Date();
    var tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 30);

    this.state = {
      showClosed: true,
      showRes: true,
      showCtoA: false,
      showCtoD: false,
      showMaxS: false,
      showMinS: true,
      showPanels: true,
      showDays: 4,
    };
  }

  handleClickOpen() {
    //  setOpen(true);
  }

  handleCustomChange(event, owner) {
    this.setState({ [owner]: event.target.value }, () => {});
    //    if (owner == 'hotelid') this.updateRoomTypes(event.target.value);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.open !== this.props.open && this.props.open == true) {
      var showClosed = true,
        showRes = true,
        showMinS = true,
        showMaxS = false,
        showCtoA = false,
        showCtoD = false,
        showPanel = true,
        showDays = 4;
      var showClose = localStorage.getItem('cockpitShowClose');
      if (showClose == null || showClose == '' || showClose == undefined) showClose = '1';
      if (showClose != '1') showClosed = false;

      var showDaysv = parseInt(localStorage.getItem('lastViewMode')) + 1;
      if (showDaysv == null || showDaysv == '' || showDaysv == undefined) showDaysv = 4;
      showDays = showDaysv;
      //console.log('showdays' + showDaysv);
      var showPanels = localStorage.getItem('cockpitShowPanel');
      if (showPanels == null || showPanels == '' || showPanels == undefined) showPanels = '1';
      if (showPanels != '1') showPanel = false;

      var showRes = localStorage.getItem('cockpitShowRes');
      if (showRes == null || showRes == '' || showRes == undefined) showRes = '1';
      if (showRes != '1') showRes = false;

      var showMinSs = localStorage.getItem('cockpitShowMinS');
      if (showMinSs == null || showMinSs == '' || showMinSs == undefined) showMinSs = '1';
      if (showMinSs != '1') showMinS = false;

      var showMaxSs = localStorage.getItem('cockpitShowMaxS');
      if (showMaxSs == null || showMaxSs == '' || showMaxSs == undefined) showMaxSs = '0';
      if (showMaxSs == '1') showMaxS = true;

      var showCtoAs = localStorage.getItem('cockpitShowCtoA');
      if (showCtoAs == null || showCtoAs == '' || showCtoAs == undefined) showCtoAs = '0';
      if (showCtoAs == '1') showCtoA = true;

      var showCtoDs = localStorage.getItem('cockpitShowCtoD');
      if (showCtoDs == null || showCtoDs == '' || showCtoDs == undefined) showCtoDs = '0';
      if (showCtoDs == '1') showCtoD = true;

      this.setState({
        showClosed: showClosed,
        showRes: showRes,
        showMinS: showMinS,
        showCtoA: showCtoA,
        showCtoD: showCtoD,
        showMaxS: showMaxS,
        showPanel: showPanel,
        showDays: showDays,
      });
    } /*

            //      this.setState({ resId: this.props.resId });
            const senddata = {
                Action: 'get_reservation_details',
                Version: 1,
                Data: {
                    HotelId: '132',
                    AllGuest: 1,
                    ReservationId: this.props.resId,
                },
            };

            axios.post(`https://secure.webbookingpro.com/api/pass.php`, senddata).then(res => {
                const renderData = [
                    { title: <IntlMessages id="res.id" />, desc: this.props.resId, icon: '' },
                    { title: '', desc: '', icon: '' },
                    { title: <IntlMessages id="res.arrival" />, desc: res.data.Data[0].Arrival, icon: '' },
                    { title: <IntlMessages id="res.departure" />, desc: res.data.Data[0].Departure, icon: '' },
                    {
                        title: <IntlMessages id="res.guest" />,
                        desc: res.data.Data[0].Guests[0].FirstName + ' ' + res.data.Data[0].Guests[0].LastName,
                        icon: '',
                    },
                    { title: <IntlMessages id="res.status" />, desc: this.props.resStatus, icon: '' },
                    { title: <IntlMessages id="res.adults" />, desc: res.data.Data[0].Adults, icon: '' },
                    { title: <IntlMessages id="res.children" />, desc: res.data.Data[0].Kids, icon: '' },
                ];
                var guests = res.data.Data[0].Guests;
                var rows = [];
                guests.forEach(function(item, index) {
                    rows.push(createData(item.FirstName + ' ' + item.LastName, ''));
                });

                this.setState({ data: renderData });
                this.setState({ rows: rows });
            });
        }*/
  }

  componentDidMount() {}

  handleChange(name, value) {
    console.log('change ' + name + ' - ');
    console.log(value);
    if (value == null) return;
    this.setState({ [name]: value }, () => {
      //   this.updateRooms();
    });
  }

  handleSubmit() {
    localStorage.setItem('lastViewMode', this.state.showDays - 1);

    if (this.state.showDays == 1) this.props.setState({ cellWidth: 80, viewMode: 0 });
    if (this.state.showDays == 2) this.props.setState({ cellWidth: 60, viewMode: 1 });
    if (this.state.showDays == 3) this.props.setState({ cellWidth: 40, viewMode: 2 });
    if (this.state.showDays == 4) this.props.setState({ cellWidth: 20, viewMode: 3 });

    this.props.setState({ settingsForm: false });
    this.props.refresh();
  }

  checkDates() {
    if (this.state.date2 == null || Number(this.state.date2) <= Number(this.state.date1)) {
      var newdate = new Date(this.state.date1);
      newdate.setDate(newdate.getDate() + 1);
      console.log(newdate);
      this.setState({ date2: newdate });
    }
  }

  handleClose() {
    this.props.setState({ settingsForm: false });
  }

  render() {
    const { classes } = this.props;
    var hotels = this.props.auth.authUser.hotels;

    return (
      <div>
        <Dialog open={this.props.open} onClose={this.handleClose} TransitionComponent={Transition}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                <IntlMessages id="settings" />
              </Typography>
            </Toolbar>
          </AppBar>
          <Box className={classes.boxTop}>
            <CmtCard className={classes.card}>
              <CmtCardContent className={classes.cardContent}>
                <Box className={classes.cardContentInner}>
                  <IntlMessages id="settings.nrWeeks" />
                  <Slider
                    aria-label="Temperature"
                    value={this.state.showDays}
                    onChange={(event, newValue) => {
                      this.handleChange('showDays', newValue);
                    }}
                    valueLabelDisplay="auto"
                    step={1}
                    marks
                    min={1}
                    max={4}
                  />
                </Box>

                <Box className={classes.cardContentInner}>
                  <Button
                    disabled={this.state.working == true}
                    variant="contained"
                    color="primary"
                    onClick={this.handleSubmit}>
                    <IntlMessages id="bulk.doChanges" />
                  </Button>
                </Box>
              </CmtCardContent>
            </CmtCard>
          </Box>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

export default withStyles(useStyles)(connect(mapStateToProps)(injectIntl(SettingsForm2)));
